<script setup lang="ts">
import { computed } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const modals = useModalsStore()

const classes = computed(() => ({
  'app-modal-add-to-cart': true,
}))
</script>

<template>
  <VueFinalModal
    v-model="modals.isAddToCartModalOpen"
    :class="classes"
    content-class="app-modal-add-to-cart__content-wrapper"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    swipe-to-close="none"
    @close="modals.closeLoginModal"
  >
    <AppModalAddToCartContent />
  </VueFinalModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-add-to-cart {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow-y: scroll;

  @include media-breakpoint-down(md) {
    .app-container {
      padding-left: 0;
      padding-right: 0;
      overflow: hidden;
    }
  }
}

.app-modal-add-to-cart__header {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 3.375rem;
  margin-bottom: 0.75rem;
}

.app-modal-add-to-cart__content-wrapper {
  position: relative;
  max-width: 100%;
  width: 100%;
}

.app-modal-add-to-cart__content {
  position: relative;
  padding: 0.75rem 0.75rem 0.75rem;
  background-color: $white;
  border-radius: 0.5rem 0.5rem 0 0;
  box-shadow: 0.125rem 0.625rem 2rem 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;

  @include media-breakpoint-up(md) {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
    padding: 2.5rem 2.5rem 1rem;
  }
}
</style>
